import React from "react";
import "./Impact.css";
import Gallery from "../components/Gallery";

export default function ImpactSection() {
  return (
    <div className="container">
      <section className="impact-section" id="impact">
                  <h2>Our Impact</h2>
        <div className="impact-container">
          <div className="impact-divider">
            <h2>Mapesa Foundation’s 2024: A Year of Purpose in Motion</h2>
          </div>

          <div className="impact-content">
            <p>
              2024 marked a powerful beginning for the Mapesa Foundation – a
              year where vision turned into impact; a bold declaration of
              intent. This was the year Mapesa Foundation took its first steps,
              not with hesitation, but with heart, drive, and a deep commitment
              to meaningful change. We began with the Official Launch of the
              Foundation – a gathering of minds and hearts, where our mission
              came to life. It was not just a celebration; it was a start of a
              movement dedicated to empowering communities and restoring dignity
              in the Polokwane community.
            </p>

            <p>
              In August, during Women’s Month, we hosted an impactful Pad Drive.
              What began as a call to action became a symbol of solidarity.
              Through community support, we provided sanitary products to young
              girls who often face the monthly challenge in silence. This was
              more than a donation – it was about access, education and ensuring
              that no girl is held back because of her period.
            </p>

            <p>
              As the year rolled into summer, the energy turned electric with
              our 1st Annual Netball & Soccer Tournament in December. This
              wasn’t just a sports event – it was a celebration of youth,
              talent, and community spirit. With Laughter on the sidelines and
              goals on the field, we witnessed how sports can unite, uplift and
              inspire.
            </p>

            <p>
              Throughout the year, our Grocery Donation Drive became lifelines
              for families facing food insecurity. These were moments of real
              connection – opportunities to show up for those in need, one
              household at a time.
            </p>

            <p>
              Our Foundation also proudly attended the 7th Annual Raising
              Legends Summit – a Gender-Based Violence Intervention Initiative
              focused on mentoring, supporting, and grooming boy children to
              become leaders, fathers, husbands and protectors.
            </p>

            <p>
              To expand our reach, we also participated in the Polokwane Tourism
              Market, using the platform to spotlight our initiatives and forge
              new connections; ultimately positioning the Foundation as a
              dynamic force in community development and social innovation.
            </p>

            <p>
              From our Foundation’s launch to the final goal scored in December,
              the year 2024 was about laying bricks of impact, one initiative at
              a time. And if this year proved anything, it’s this: when purpose
              meets action, communities rise. We are only getting started.
            </p>
          </div>
          
          <Gallery />
        </div>
      </section>
    </div>
  );
}
